import { css } from 'styled-components'
import { merchantThemes } from '../../../Variable'

export function getCheckbox(props) {
	return (
		props.theme.name === merchantThemes.asket &&
		css`
			span {
				&::before {
					border-color: ${({ theme }) => theme.color.blackOne};
				}
			}
			input:checked + span {
				&::before {
					background-color: ${({ theme }) => theme.color.blackOne};
				}
				&::after {
					border-color: ${({ theme }) => theme.color.secondary};
				}
			}
			input:disabled + span {
				&::before {
				}
				&::after {
				}
			}
		`
	)
}
